import { createContext, useContext, useRef, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { updatePlan, addPlan, getPlans } from "../../api/plans";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getFormattedDateforAPI } from "../../utils/format-date";
const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const AddWorkArray = useRef();
  const toaster = useToaster();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const navigate = useNavigate();

  const getPlanQuery = useQuery({
    queryKey: [{ id }],
    queryFn: getPlans,
    enabled: !!id,
  });

  const updatePlanQuery = useMutation({ mutationFn: updatePlan });
  const addPlanQuery = useMutation({ mutationFn: addPlan });

  const initialValues = useMemo(() => {
    const [data] = getPlanQuery?.data?.data?.data || [];
    return {
      title: data?.plan_title || "",
      description: data?.plan_description || "",
      plan_price: data?.plan_price === 0 ? 0 : data?.plan_price || "",
      currency: data?.currency || "",
      billing_period: data?.billing_period || "",
      plan_features: data?.plan_features || [{ feature: "" }],
      discount_type: data?.discount_type || "",
      discount_value: data?.discount_value || "",
      start_date: data?.start_date ? [data?.start_date] : [],
      expiry_date: data?.expiry_date ? [data?.expiry_date] : [],
      on_hover_heading: data?.on_hover_heading || "",
      cta_button: data?.cta_button || "",
      is_published: data?.is_published,
      gst: data?.gst
    };
  }, [getPlanQuery]);

  const handleSubmit = async (values) => {
    const payload = {
      plan_title: values?.title || "",
      plan_description: values?.description || "",
      plan_price: values?.plan_price === 0 ? 0 : values?.plan_price || "",
      currency: values?.currency || "",
      billing_period: values?.billing_period || "",
      plan_features: values?.plan_features || [{ feature: "" }],
      discount_type: values?.discount_type || "",
      discount_value: values?.discount_value || "",
      start_date: getFormattedDateforAPI([values?.start_date?.[0]]),
      expiry_date: getFormattedDateforAPI([values?.expiry_date?.[0]]),
      on_hover_heading: values?.on_hover_heading || "",
      cta_button: values?.cta_button || "",
      is_published: values?.is_published,
      gst: values?.gst
    };

    if (id) {
      payload.id = id;
      updatePlanQuery.mutate(payload, {
        onSuccess: () => {
          toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
        },
      });
      return;
    }
    addPlanQuery.mutate(payload, {
      onSuccess: () => {
        navigate(-1);
        toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_ADDED_SUCCESSFULLY);
      },
    });
  };

  const handleNewWorkAdd = () => {
    AddWorkArray.current.push({ image_link: "" });
  };

  const handleNewWorkDelete = (index) => () => {
    AddWorkArray.current.remove(index);
  };
  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleNewWorkDelete,
        AddWorkArray,
        handleNewWorkAdd,
        getPlanQuery,
        handleSubmit,
        id,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const useAddWorkProvider = () => {
  return useContext(PageContext);
};
